import React from "react";
import Block from "Components/Core/Block";
import 'CSS/Modal.css';
export default function Modal(props) {

    const x = props.x;

	x.was.setModal = setModal;

	function setModal(set) {
		if (set) {
			x.wab[props.id].show();
		}
		else {
			x.wab[props.id].hide();
		}
	}

    return (
        <Block id={props.id} x={x}  classes={`webapp-modal `} />
    );


}
